import { render, staticRenderFns } from "./PromotionsWindow.vue?vue&type=template&id=7b4e5611&scoped=true&"
import script from "./PromotionsWindow.vue?vue&type=script&lang=js&"
export * from "./PromotionsWindow.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsWindow.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PromotionsWindow.vue?vue&type=style&index=1&id=7b4e5611&lang=less&scoped=true&"
import style2 from "./PromotionsWindow.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4e5611",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBadge,VBtn,VBtnToggle,VCol,VRow,VTextField})
